<div *ngIf="global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
    <div class="row mb-2">
        <div class="col pl-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <div class="text-center text-danger">
                        <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                            details</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row" *ngIf="global.globalAgencyId!=null && global.globalAgencyId!=undefined &&
global.globalAgencyId!='' && global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
    <div class="col-12 mb-2">
        <h4 class="font-header-1">Upload LEIE</h4>
    </div>
    <div class="col-12 mt-2">
        <div class="card">
            <div class="card-body">
                <div class="row mt-2 mb-2">
                    <div class="col-8 d-flex">
                        <input #files type="file" class="form-control" accept=".csv"
                            (change)="onDOCFileChanged($event.target.files);selected=!selected;"
                            (click)="files.value=null" style="height:28px;flex:1">
                        <button class="btn btn-sm ms-1"><i class="fa fa-upload mt-1" (click)="uploadLEIEFile()"
                                style="color:#fbfbfb;font-size:10px;cursor: pointer;"></i> </button>
                    </div>
                    <div class="col-4 text-end">
                        <b><i class="fa fa-chevron-circle-left fs-2" style="color:#502189;cursor: pointer;"
                                aria-hidden="true" (click)="backToDashboard()"></i> </b>
                    </div>
                </div>

                <div class="row mt-2 pt-2">
                    <div class="col-12 mb-2 pt-2">
                        <div class="row">
                            <div class="col-6">
                                <h4 class="font-header-1">LEIE Import Log </h4>
                            </div>
                            <div class="col-6  text-lg-end">
                                <button class="btn btn-sm" data-bs-toggle="modal" data-bs-target="#modalPrint"> Print
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-2 ">
                        <ejs-grid #gridLEIELog [dataSource]='leieuploadlog | async' [allowSorting]='true'
                            [allowResizing]='true' [allowPaging]='true' [allowFiltering]='true'
                            (dataStateChange)='dataStateChange($event)' [pageSettings]='initialPage'
                            [filterSettings]='filterSettings' (actionBegin)="onActionComplete($event)"
                            (queryCellInfo)='validatebutton($event)' (resizeStop)="onResize($event)"
                            [showColumnChooser]='true'>
                            <e-columns>
                                <e-column field="viewMatchesField" headerText="Action" uid="action" textAlign='center'
                                    [allowFiltering]='false' [showInColumnChooser]='false'>
                                    <ng-template #template let-data>
                                        <button class="btn btn-edit-table text-center mr-2"
                                            (click)="getMatchedEmployeeList(data)">
                                            <i class="fa fa-eye"></i>
                                        </button>
                                    </ng-template>
                                </e-column>
                                <e-column field="importedDate" headerText="Imported Date" type='date'
                                    [allowFiltering]='false' [format]='formatOptions'></e-column>
                                <e-column field="importedBy" [allowFiltering]='false' headerText="Imported By"
                                    type='string'></e-column>
                                <e-column field="matchesFound" headerText="Matches Found" type='number'></e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal" tabindex="-1" id="modalPrint" data-bs-backdrop="false"
    style=" background-color: rgba(1, 1, 1, 0.71);">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title bold">Print confirmation</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p> Do you want to print this record?.</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm" (click)="printLeie()">Print</button>
            </div>
        </div>
    </div>
</div>



<span id="MatchedEmployeeModal" data-bs-toggle="modal" data-bs-target="#ExampleModal"></span>
<div class="modal" tabindex="-1" id="ExampleModal" data-bs-backdrop="false"
    style=" background-color: rgba(1, 1, 1, 0.71);">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title bold">LEIE Matches</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <kendo-pdf-export #pdfLEIE paperSize="A4" forcePageBreak=".page-break" margin="0.8cm">
                    <div style="width:730px ;padding-left:15px">
                        <div id="printsec">
                            <div class="row">
                                <div class="col-lg-6 col-md-2 col-sm-12 text-center">
                                    <h4>LEIE</h4>
                                </div>
                                <div class="col-lg-6 col-md-12 col-sm-12 text-center">
                                    <h4>Employee</h4>
                                </div>
                            </div>
                            <hr>

                            <ng-container *ngFor="let le of getMatchEmpBO">
                                <div class="row">
                                    <div class="col-lg-6 col-md-12 col-sm-12" style="border-right: solid 1px #000000;">
                                        <div class="row mt-2">
                                            <div class="col-lg-12 fs-5 bold">{{le.leiebOs.lastname}},
                                                {{le.leiebOs.firstname}}
                                                {{le.leiebOs.midname}}</div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-4 bold">DOB:</div>
                                            <div class="col-8">{{le.leiebOs.dob |date:'MM/dd/yyyy'}}</div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-4 bold">Address:</div>
                                            <div class="col-8">
                                                <div class="row">{{le.leiebOs.address}}</div>
                                                <div class="row">{{le.leiebOs.city}}</div>
                                                <div class="row">{{le.leiebOs.state}}</div>
                                                <div class="row">{{le.leiebOs.zipcode}}</div>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-4 bold">SPECIALITY:</div>
                                            <div class="col-8">{{le.leiebOs.specialty}}</div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-4 bold">UPIN:</div>
                                            <div class="col-8">{{le.leiebOs.upin}}</div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-4 bold">NPI:</div>
                                            <div class="col-8">{{le.leiebOs.npi}}</div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-4 bold">EXCLTYPE:</div>
                                            <div class="col-8">{{le.leiebOs.excltype}}</div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-4 bold">EXCLDATE:</div>
                                            <div class="col-8">{{le.leiebOs.excldate |date:'MM/dd/yyyy'}}</div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-4 bold">REINDATE:</div>
                                            <div class="col-8">{{le.leiebOs.reindate |date:'MM/dd/yyyy'}}</div>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-md-12 col-sm-12">
                                        <div class="row mt-2">
                                            <div class="col-lg-12 fs-5 bold">{{le.employeeBOs.lastName}},
                                                {{le.employeeBOs.firstName}} {{le.employeeBOs.middleName}}

                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-4 bold">STATUS:</div>
                                            <div class="col-8">({{le.employeeBOs.statusLidName}}) </div>
                                        </div>

                                        <div class="row mt-2">
                                            <div class="col-4 bold">DOB:</div>
                                            <div class="col-8">{{le.employeeBOs.dob |date:'MM/dd/yyyy'}}</div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-4 bold">Address:</div>
                                            <div class="col-8">
                                                <div class="row">{{le.employeeBOs.steet}}</div>
                                                <div class="row">{{le.employeeBOs.city}}</div>
                                                <div class="row">{{le.employeeBOs.county}}</div>
                                                <div class="row">{{le.employeeBOs.zipcode}}</div>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-4 bold">NPI:</div>
                                            <div class="col-8">{{le.employeeBOs.rnnpi}}</div>
                                        </div>
                                    </div>
                                </div>
                                <hr>
                            </ng-container>
                        </div>

                    </div>
                </kendo-pdf-export>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm" (click)="printLEIE()">Print</button>
            </div>
        </div>
    </div>
</div>